<template>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css"/>
<link  rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"/>
<link  rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"/>
   <header class= "header-main">
    <section>
        <div class="container">
                        <nav class="navbar navbar-expand-lg">
            <div class="container-fluid">
                <a class="navbar-brand" href="#">  <img alt=" logo" src="../assets/images/rockstar-logo.png"></a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <router-link to="/">Home</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{ name: 'Subscription' }">Subscriptions</router-link>
                    </li>
                    <!-- <li class="nav-item">
                        <router-link :to="{ name:'Streaks' }">Streaks</router-link>
                    </li> -->
                    <li class="nav-item">
                        <router-link :to="{ name:'Login' }" v-if="!isLoggedIn">Login</router-link>
                        <router-link :to="{ name:'Login' }" v-else @click="logout">Logout</router-link>
                    </li>
                </ul>
                </div>
            </div>
            </nav>
            
                    </div>
           </section>
       </header>
</template>
<script>
import axios from 'axios';

export default {
    name: 'HeaderMain',
    inject: ['api'],
    props: {
        msg: String
    },

    computed: {
        isLoggedIn() {
            return localStorage.getItem('rockstar_token') !== null;
        }
    },

    methods: {
        async logout() {
            const confirmLogout = confirm('Are you sure you want to log out?'); // Show confirmation alert
            if (!confirmLogout) {
                return; // Exit if the user cancels
            }

            try {
                // Hit the logout API
                const token = localStorage.getItem('rockstar_token'); // Get token from localStorage
                await axios.post(`${this.api.base_url}/user/logout`, {}, {
                    headers: {
                        'token': this.api.token,
                        'user-token': token,
                    },
                });

                // Remove rockstar_token and rockstar_user from localStorage
                localStorage.removeItem('rockstar_token');
                localStorage.removeItem('rockstar_user');

                // Redirect to login page
                this.$router.push({ name: 'Login' });
            } catch (error) {
                console.error('Error during logout:', error);
            }
        },
    }
};
</script>